export const history = {
  navigate: null,
  location: null,
  toast: null,
};
